module.exports = __webpack_public_path__ + "sombra_leitura.png?641a1d6a1a591eafff3a5ebf08d8cbbe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sombra_leitura.png
// module id = 68
// module chunks = 0